<script>
import addressMixin from "@/mixins/addressMixin";

export default {
  mixins: [addressMixin],

  props: {
    address: {
      type: Object,
      required: true
    }
  }
};
</script>

<template>
  <div class="address-selected">
    <span class="address-label">
      {{ address | name }}
    </span>

    <span class="address-street">
      {{ address | streetAddress }}
    </span>
  </div>
</template>

<style scoped>
.address-selected {
  width: calc(100% - 36px);
  display: flex;
  flex-direction: column;
  user-select: none;
}

.address-label {
  font-size: 15px;
  font-weight: 400;
  color: #603285;
}

.address-street {
  font-size: 13px;
  color: #666;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/Address/SelectedAddress.vue